import React from 'react';

import { classNames } from '@/helpers/classNames';

import styles from '../Onboarding.module.scss';

const InnerStepThree: React.FC = () => {
	return (
		<>
			<div className={styles['heading']}>
				<img
					className={styles['svg']}
					src="/assets/onboarding-icons/plus.svg"
				/>
				Create better sets
			</div>
			<div className={classNames([styles['text'], 'mt-sm'])}>
				Generate with AI or craft yourself. Use insights from scripture,
				themes and feedback.
			</div>
		</>
	);
};

export default InnerStepThree;
